import React from "react";
import AppButton from "../../../../components/AppButton";
import AppTooltip from "../../../../components/AppTooltip";
import { IconFilter, IconInfo } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const niceToKnowItems = [
  "Vorschau zeigt nur einige Einsatz-Beispiele",
  "Text kurz halten: ideal 1 bis 2 Zeilen.",
  "Keine Pflichtinformation nur im Tooltip verstecken.",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

export default function TooltipDocs() {
  return (
    <DocsSectionCard title="Tooltip">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--tooltip">
        <DocsPreviewPanel className="ds-docs-tooltip-preview-panel">
          <div className="ds-docs-preview-surface ds-docs-tooltip-preview">
            <PreviewRow label="Icon">
              <AppTooltip content="Filter öffnen">
                <AppButton variant="muted" size="sm" iconOnly aria-label="Filter öffnen">
                  <IconFilter sx={{ fontSize: 18 }} />
                </AppButton>
              </AppTooltip>
            </PreviewRow>

            <PreviewRow label="Info">
              <AppTooltip content="Wird bei der Planung als Präferenz berücksichtigt.">
                <IconInfo sx={{ fontSize: 16 }} aria-label="Information" />
              </AppTooltip>
            </PreviewRow>

            <PreviewRow label="Disabled">
              <AppTooltip content="Momentan nicht verfügbar.">
                <AppButton variant="neutral" size="sm" disabled>
                  Aktion
                </AppButton>
              </AppTooltip>
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
